import Hero from "../../components/Service/Hero";
import '../../scss/ai.scss'
import {data} from "../../data/ai";
import HeroTitle from "../../components/Service/HeroTitle";
import HeroText from "../../components/Service/HeroText";
import Section from "../../components/Service/Section";
import { decodeEntities } from "@wordpress/html-entities";
import buttonClasses from "../../components/commons/Button.module.scss";
import React from "react";
import ContactFormWrapper from "../../components/ContactFormWrapper";
import { v4 as uuid } from "uuid";
import {NavLink} from 'react-router-dom'

const AI = () => {
    return(
          <>
              <Hero className='ai_service_hero'>
                  <div className='hero_content_container'
                       style={{
                           backgroundImage: `url(${data.hero.image_back})`
                       }}

                  >
                      <div className="hero_slide hero_slide_left">
                          <HeroTitle
                              title={data.hero.title}
                              className='ai_title'
                          />
                          <HeroText text={data.hero.text} className='ai_desc' />
                          <NavLink
                              data-content="REQUEST DEMO"
                              className={`${buttonClasses.button} white_btn`}
                              to={'/contact-us'}
                          >
                              REQUEST DEMO
                          </NavLink>
                      </div>
                      <div className="hero_slide hero_slide_right">
                          <img src={data.hero.image} alt=""/>
                      </div>

                  </div>
              </Hero>
              <Section className='about_ai_section'>
                  <div className="about_inner">
                      <div className="overlay"
                           style={{
                               backgroundImage: `url(${data.about.image})`
                           }}
                      />
                      <div className="inner_content">
                          <HeroTitle
                              title={data.about.title}
                              className='about_title'
                          />
                          <HeroText text={data.about.text} className='about_desc' />
                      </div>

                  </div>
              </Section>
              <section className='ai_services'>

                  <div className="ai_services_content">
                      <div className="services_overlay"
                           style={{
                               backgroundImage: `url(${data.services.image})`
                           }}
                      />
                    <div className="services_top_content">
                        <h3 className="content_title">
                            {data.services.title}
                        </h3>
                        <p>
                            {data.services.text}
                        </p>
                    </div>
                      <div className="ai_services_list">
                          {data.services.list.map(({title, desc}) => {
                              return(
                                  <div className='list_item' key={uuid()}>
                                      <h3>{title}</h3>
                                      <p>{desc}</p>
                                  </div>
                              )
                          })}
                      </div>
                  </div>
              </section>
              <section className="company_preview">
                  <div className="image_overlay"
                       style={{
                           backgroundImage: `url(${data.company.image})`
                       }}
                  />
                    <div className="preview_content">
                        <HeroTitle
                            title={data.company.title}
                            className='ai_title'
                        />
                        <p className='first_desc'  dangerouslySetInnerHTML={{
            __html: decodeEntities(data.company.content),
          }}/>
                        <p className='second_desc'  dangerouslySetInnerHTML={{
            __html: decodeEntities(data.company.content2),
          }}/>
                        <NavLink
                            data-content="REQUEST DEMO"
                            className={`${buttonClasses.button} ai_btn`}
                            to={'/contact-us'}
                        >
                            REQUEST DEMO
                        </NavLink>
                    </div>
              </section>
              <ContactFormWrapper />
          </>
    )
}

export default AI